// TODO: Update colors if needed
export const Palette = {
  BLACK: '#000000',
  BLACK_20: '#BBBBBB',
  BLACK_50: '#757575',
  BLACK_0: '#343B43',
  WHITE: '#FFFFFF',
  WHITE_SMOKE: '#F1F4F9',
  CONTENT_TERTIARY: '#737373',
  DARK_ASH: '#131A2C',
  SOLITUDE: '#E9EDF3',
  SOLITUDE2: '#e9edf2',
  GHOST_WHITE: '#F8F8FA',
  ERROR: '#EA4444',
  STROKE_GREY: '#C3C3C3',
  HAZY_BLUE: '#133155',
  LIGHT_GREY: '#7C8DA1',
  OCEANIC: '#4697E0',
  BRAND_DARK_BLUE: '#D0D1D5',
  OCEANIC_60: '#8ECAFF',
  OCEANIC_100: '#DAEAF9',
  OCEANIC_NAV_HOVER: '#2D4664',
  LIGHT_GREY: '#96A9BC',
  LIGHT_BLUE: '#34B3F1',
  CONTENT_NEGATIVE: '#E14141',
  CONTENT_DISABLED: '#A3A3A3',
  GREEN_500: '#53A35B',
  DISABLED: '#D4D4D4',
  GREY_50: '#F4F4F4',
  GREY_100: '#F5F5F5',
  TRANS_GREY: 'rgba(0, 0, 0, 0.25)',
  SHUTTLE_GREY: '#606770',
  TRANS_GREY_BG: 'rgba(0, 0, 0, 0.1)',
  RUSTY_ORANGE: '#E3843C',
  ORANGE_100: '#F9E4D3',
  ORANGE_500: '#DF7A24',
  CUSTOM_GRAY: '#6B6A6A',
  CUSTOM_GRAY_2: '#D6D6D6',
  OCEANIC_HOVER: '#6BACE6',
  BACKGROUND_TAG_GREEN: 'rgba(83, 163, 91, 0.2)',
  TEXT_TAG_GREEN: 'rgba(83, 163, 91, 1)',
  BACKGROUND_TAG_RED: '#FCE0E0',
  FIELD_TEXT: '#ECECEC',
  STAR_GREEN: '#009688',
  ACTIVE_GREEN_BACKGROUND: '#DCF0F1',
  ACTIVE_GREEN: '#53A35B',
  BRAND_BLUE: '#143154',
  PURPLE: '#8A46E0',
  BORDER_OUTLINE: 'rgba(19, 26, 44, 0.50)',
  DARK_GRAY: '#636363',
  BACKGROUND_TAG_GREY: 'rgba(99, 99, 99, 0.2)',
  CYAN_100: '#DAEAFB',
  CYAN_500: '#4594EC',
  YELLOW_100: '#FAF2D5',
  YELLOW_700: '#8B721C',
  VIOLET_100: '#DFD5FB',
  VIOLET_500: '#5F2CEA',
  SURFACE_SUCCESS: '#DDEDDE',
  BORDER_STRONG: '#424856'
};
